export default __webpack_public_path__ + "static/media/02_Business-Portrait-EschweilerPhotography_21A9848_1.c9bb583b.jpg";